import * as React from 'react';
import { Controller, MainMenu, StateManager, Toolbar, Menu, skipWithDefault, UseBefore, awaitLoad, Param, ActionPointInfo, IActionPointInfo } from '@tencent/workbench';
import DocsConfig from '@tencent/docs-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { TOOLBAR_ITEMS, MENU_CONFIGS, config } from './config';
import { AddonUnofficialFeature } from './addon-unofficial-feature';
import { wrapIdForBig, wrapIdForCommon } from '@framework/workbench/util/wrap-id-util';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { AddonToolbarMiddleware } from '@framework/workbench/middleware/addon-middleware';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import ua from '@tencent/docs-user-agent';
import { getPcInjectedService } from '../../util/injector-service';

/**
 * 插件/智能工具
 */
@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class AddonUnofficialController {
    private baseAddonService;
    public constructor(
        private readonly feature: AddonUnofficialFeature,
        private readonly stateManager: StateManager,
    ) {
        this.getBaseAddonService();
    }

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    @Toolbar(wrapIdForCommon(config.id), 'dropdownContent')
    @UseBefore(AddonToolbarMiddleware)
    public insertDropdown() {
        this.feature.twdReport();
        return <MainMenu align="left" name={config.id} mode="menu" itemStyle={{ width: 166 }} />;
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    @Toolbar(wrapIdForBig(config.id), 'onDropdownVisibleChange')
    @Toolbar(wrapIdForCommon(config.id), 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }

    @Toolbar(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    @Toolbar(wrapIdForCommon(config.id), 'shouldHide')
    @Menu(config.id, 'shouldHide')
    public shouldHide() {
        return !DocsConfig.getInstance().getConfig(ToolbarFileMenuConfig.addonUnofficial);
    }

    @Menu(ActionType.EXTERNAL_ADDONS_PANEL_TITLE, 'shouldDisabled')
    @skipWithDefault(true)
    public shouldPanelTitleDisabled() {
        return true;
    }

    @Menu('addon-unoffcial-:menuid', 'onClick')
    @awaitLoad()
    public onAddonClick(@Param('menuid') menuId: string) {
        this.baseAddonService?.clickUnOfficialCallbacks?.get(menuId)?.();
    }

    @Menu('addon-unoffcial-:menuid', 'shouldDisabled')
    public shouldAddonUnofficalDisabled() {
        if ((browser.isPc && browser.isMiniProgram) || ua.isTencentMeeting) {
            return true;
        }
        return false;
    }

    @Toolbar(config.id, 'shouldDisabled')
    @Toolbar(wrapIdForBig(config.id), 'shouldDisabled')
    @Toolbar(wrapIdForCommon(config.id), 'shouldDisabled')
    @Menu(config.id, 'shouldDisabled')
    public shouldDisabled(): boolean {
        return this.feature.shouldDisabled(config.id);
    }

    private getBaseAddonService = async () => {
        if (this.baseAddonService) return;
        return import(/* webpackChunkName: "addon" */ '@framework/workbench/common/service/base-addon-service')
            .then((module) => {
                const { BaseAddonService } = module;
                this.baseAddonService = getPcInjectedService(BaseAddonService);
            })
            .catch((error) => {
                window.log.error(`[loadChunk-error]${error}`);
            });
    };
}
